import React from "react";

const MarqueeSection = () => {

    return (
        <div className="digital-marque-sec">
            <div className="digital-marque">
                <div className="marquee">
                    <div className="track">
                        <div className="content">
                            <h1>
                                <span>TDAH<i className="ti-star"></i></span>
                                <span>DISLEXIA<i className="ti-star"></i></span>
                                <span>DIFICULDADE DE APRENDIZAGEM<i className="ti-star"></i></span>
                                <span>ALTAS HABILIDADES<i className="ti-star"></i></span>
                                <span>SUPERDOTAÇÃO<i className="ti-star"></i></span>
                                <span>TDAH<i className="ti-star"></i></span>
                                <span>DISLEXIA<i className="ti-star"></i></span>
                                <span>DIFICULDADE DE APRENDIZAGEM<i className="ti-star"></i></span>
                                <span>ALTAS HABILIDADES<i className="ti-star"></i></span>
                                <span>SUPERDOTAÇÃO<i className="ti-star"></i></span>
                                <span>TDAH<i className="ti-star"></i></span>
                                <span>DISLEXIA<i className="ti-star"></i></span>
                                <span>DIFICULDADE DE APRENDIZAGEM<i className="ti-star"></i></span>
                                <span>ALTAS HABILIDADES<i className="ti-star"></i></span>
                                <span>SUPERDOTAÇÃO<i className="ti-star"></i></span>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarqueeSection;